<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container">
        <b-loading
          :is-full-page="true"
          :active="isLoading"
          :can-cancel="false"
        ></b-loading>

        <div class="columns">
          <div class="column"></div>
          <div class="column is-half has-text-centered">
            <img
              id="logo-navbar"
              src="../../assets/img/logo-mq.png"
              width="170"
              height="22"
              alt="Logo Minha Quitandinha"
              title="MQ"
              v-if="$chain === 'mq'"
            />

            <img
              id="logo-navbar"
              src="../../assets/img/logo-brmania.png"
              width="170"
              height="22"
              alt="Logo BR Mania"
              title="BR Mania"
              v-else-if="$chain === 'brmania'"
            />

            <img
              id="logo-navbar"
              src="../../assets/img/logo-smart-orange-outline.png"
              width="170"
              height="22"
              alt="Logo Onii"
              title="Onii"
              v-else
            />

            <h1 class="is-size-3 has-text-weight-semibold">
              {{ $t("login.redefinePassword") }}
            </h1>

            <h2 class="subtitle">
              {{ $t("login.passwordConditions") }}
            </h2>

            <form @submit.prevent="resetPassword">
              <b-field>
                <b-input
                  size="is-medium"
                  v-model="password"
                  class="is-expanded"
                  type="password"
                  :placeholder="$t('common.password')"
                  password-reveal
                ></b-input>
              </b-field>

              <b-field>
                <b-input
                  size="is-medium"
                  v-model="passwordConfirmation"
                  class="is-expanded"
                  type="password"
                  :placeholder="$t('common.passwordConfirmation')"
                  password-reveal
                ></b-input>
              </b-field>

              <button
                class="button is-medium is-fullwidth has-text-weight-bold"
                :style="{
                  backgroundColor: $primaryColor,
                  color: $primaryColorContrast
                }"
              >
                {{ $t("login.redefinePassword") }}
              </button>
            </form>
          </div>
          <div class="column"></div>
        </div>
      </div>
    </div>

    <div class="hero-footer">
      <flag-icons />
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common.js";
import flagIcons from "./common/FlagIcons";

export default {
  mixins: [common],

  components: {
    flagIcons
  },

  data() {
    return {
      isLoading: false,
      resetToken: "",
      password: "",
      passwordConfirmation: ""
    };
  },

  methods: {
    resetPassword() {
      this.isLoading = true;
      this.$store
        .dispatch("resetPassword", {
          resetToken: this.resetToken,
          password: this.password,
          passwordConfirmation: this.passwordConfirmation
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else if (res.data.result === "ok") {
            this.$buefy.dialog.alert({
              title: this.$t("common.success"),
              message: this.$t("login.youCanLoginWithYourNewPassword"),
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa",
              onConfirm: () => this.$router.push("/"),
              onCancel: () => this.$router.push("/")
            });
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters(["locale"])
  },

  mounted() {
    this.$store.dispatch("setLocale", this.locale);
    this.resetToken = this.$route.query.resetToken;
  }
};
</script>

<style>
form {
  width: 80%;
  margin: auto;
}
</style>
